import { useEffect, useRef, type RefObject } from 'react';

/**
 * When `present` turns false and focus has fallen back to <body> (the focused control
 * went away with it), focus `target` so a keyboard user keeps their place.
 */
export function useKeepFocusWhenGone(present: boolean, target: RefObject<HTMLElement | null>) {
  const was = useRef(present);
  useEffect(() => {
    if (was.current && !present && document.activeElement === document.body) target.current?.focus();
    was.current = present;
  }, [present, target]);
}
